import React from 'react';
import {Skeleton} from '@mui/material';
import './index.scss';

const SKELETON_HEADER_WIDTH = 324;
const SKELETON_HEADER_HEIGHT = 64;
const SKELETON_TITLE_WIDTH = 128;

const OrderConfirmNextStepsSkeleton: React.FC = () => {
  return (
    <div className="next-steps">
      <div className="next-steps-header">
        <Skeleton
          width={SKELETON_HEADER_WIDTH}
          height={SKELETON_HEADER_HEIGHT}
        />
      </div>
      <div className="next-steps-title">
        <Skeleton width={SKELETON_TITLE_WIDTH} />
      </div>
      <div className="next-steps-section">
        <Skeleton />
      </div>
      <div className="next-steps-title">
        <Skeleton width={SKELETON_TITLE_WIDTH} />
      </div>
      <div className="next-steps-section">
        <Skeleton />
      </div>
      <div className="next-steps-title">
        <Skeleton width={SKELETON_TITLE_WIDTH} />
      </div>
      <div className="next-steps-section">
        <Skeleton />
      </div>
    </div>
  );
};

export default OrderConfirmNextStepsSkeleton;
